import React from 'react';
import './ProjectThumbnail.css';

const ProjectThumbnail = ({ project }) => {
  const isDualPlatform = project.platforms.includes('Android') && project.platforms.includes('iOS');
  const isAndroidOnly = project.platforms.includes('Android') && !project.platforms.includes('iOS');
  const isIOSOnly = project.platforms.includes('iOS') && !project.platforms.includes('Android');

  const getSubtitle = () => {
    if (isDualPlatform) {
      return 'Live Android + iOS App';
    } else if (isAndroidOnly) {
      return 'Live Android App';
    } else if (isIOSOnly) {
      return 'Live iOS App';
    } else {
      return 'Live Project';
    }
  };

  const getBadgeText = () => {
    if (isDualPlatform) {
      return 'Android + iOS';
    } else if (isAndroidOnly) {
      return 'Android Only';
    } else if (isIOSOnly) {
      return 'iOS Only';
    } else {
      return 'Live Project';
    }
  };

  return (
    <div className={`project-thumbnail ${isDualPlatform ? 'dual-platform' : 'single-platform'}`} 
         style={{ background: project.gradient }}>
      <div className="thumbnail-pattern"></div>
      <div className="thumbnail-content">
        <div className="thumbnail-badge">
          <span className="badge-dot"></span>
          {getBadgeText()}
        </div>
        
        <div className="thumbnail-main">
          {/* Device Mockups */}
          <div className="thumbnail-mockups">
            {isDualPlatform ? (
              <>
                <div className="mockup-device iphone-mockup">
                  <div className="device-frame">
                    <div className="device-notch"></div>
                    <div className="device-screen">
                      <div className="screen-content">
                        <div className="app-icon-large"></div>
                        <div className="ui-elements">
                          <div className="ui-bar"></div>
                          <div className="ui-card"></div>
                          <div className="ui-dot"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mockup-device android-mockup">
                  <div className="device-frame">
                    <div className="device-screen">
                      <div className="screen-content">
                        <div className="app-icon-large"></div>
                        <div className="ui-elements">
                          <div className="ui-bar"></div>
                          <div className="ui-card"></div>
                          <div className="ui-dot"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className="mockup-device android-mockup single">
                <div className="device-frame">
                  <div className="device-screen">
                    <div className="screen-content">
                      <div className="app-icon-large"></div>
                      <div className="ui-elements">
                        <div className="ui-bar"></div>
                        <div className="ui-card"></div>
                        <div className="ui-dot"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          {/* Project Info */}
          <div className="thumbnail-info">
            <h2 className="thumbnail-title">{project.title}</h2>
            <p className="thumbnail-subtitle">{getSubtitle()}</p>
            <div className="thumbnail-platforms">
              {project.platforms.includes('Android') && (
                <span className="platform-badge-platform">🤖 Android</span>
              )}
              {project.platforms.includes('iOS') && (
                <span className="platform-badge-platform">🍎 iOS</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectThumbnail;
